import { Modal, Select, message } from "antd";
import * as React from "react";

export const RenderModalWindowReassignEmail = ((props:{isOpen?: boolean, isError?: boolean, onOk?:()=>void, onCancel?:()=>void, onChange?:(e:any)=>void, email?:string, newEmails?:Array<{ value: string; label: string }>})=>{

    const [messageApi ,contextHolder] = message.useMessage();

    const checkReassignEmail = () => {
            messageApi.open({
                type: 'warning',
                style:{
                    width: 450,
                    margin: 'auto'
                },
                content: `No contacts were found in the system to which reassignment could be made. Please check if there are contacts for reassignment`,
                duration: 10
            });
    }
    return(
        <>
            {contextHolder}
            {props.newEmails.length > 0 ?
                <Modal
                    title="Reassign Login email to another contact on account"
                    centered
                    open={props.isOpen}
                    onOk={() => props.onOk()}
                    onCancel={() =>props.onCancel()}
                >
                    <p>Select which contact should be associated with the email {props.email}</p>
                    <Select
                        defaultValue={props.newEmails[0]?.value}
                        style={{ width: "100%" }}
                        onChange={(e) =>props.onChange(e)}
                        options={props.newEmails}
                    />
                </Modal>
            :
            <>{(props.newEmails.length == 0 || props.newEmails == undefined) && props.isError ? checkReassignEmail()  : <></> }</>}
        </>
        
    )
})
